export const menuHeaderSizes = {
  default: 220,
  shrunk: 130,
};
